import React from "react";

import "./ErrorPage.scss";

const ErrorPage = () => {
	return <div className="error-page">Error page</div>;
};

export default ErrorPage;
